import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Button, MenuItem, Menu } from '@mui/material';
import { yellowMain } from '@ui/constants/color';
import { ArrowUp2, ArrowDown2 } from 'iconsax-react';
import { useEffect, useState } from 'react';
export const Dropdown = ({ options, onSelect, defaultOption, selectedOptions = null, color = 'yellow', disabled = false, wrapLabel = false }) => {
    const [isOpen, setIsOpen] = useState(false);
    const [selectedValue, setSelectedValue] = useState(selectedOptions);
    const [selectAnchorEl, setSelectAnchorEl] = useState(null);
    useEffect(() => {
        setSelectedValue(selectedOptions);
    }, [selectedOptions]);
    const handleClick = (event) => {
        if (disabled)
            return;
        setSelectAnchorEl(event.currentTarget);
        setIsOpen(true);
    };
    const handleMenuClose = (value) => {
        if (value && !disabled) {
            setSelectedValue(value);
            if (onSelect) {
                onSelect(value); // Pass the selected value, not label
            }
        }
        setSelectAnchorEl(null);
        setIsOpen(false);
    };
    // Find the label that corresponds to the selected value
    const selectedLabel = options.find(option => option.value === selectedValue)?.label || defaultOption || 'Select Option';
    return (_jsxs("div", { children: [_jsx(Box, { children: _jsxs(Button, { disabled: disabled, variant: 'text', size: 'small', color: 'primary', onClick: handleClick, "aria-haspopup": 'menu', "aria-expanded": isOpen, endIcon: isOpen ? _jsx(ArrowUp2, { size: '16px' }) : _jsx(ArrowDown2, { size: '16px' }), sx: {
                        justifyContent: 'space-between',
                        textTransform: 'capitalize',
                        fontSize: 14,
                        fontWeight: 500,
                        color: color === 'white' ? 'white' : yellowMain,
                        height: 'auto',
                        ...(wrapLabel ? { whiteSpace: 'normal', textAlign: 'left', overflowWrap: 'anywhere' } : {}),
                    }, children: [selectedLabel, " "] }) }), _jsx(Menu, { open: isOpen, anchorEl: selectAnchorEl, onClose: () => handleMenuClose(), anchorOrigin: {
                    vertical: 'top',
                    horizontal: 'center'
                }, transformOrigin: {
                    vertical: 'bottom',
                    horizontal: 'center'
                }, PaperProps: {
                    sx: {
                        maxHeight: 300,
                        overflowY: 'auto',
                        ...(wrapLabel ? { maxWidth: 'calc(100vw - 32px)' } : {})
                    }
                }, children: options.map((option) => (_jsx(MenuItem, { sx: wrapLabel ? { whiteSpace: 'normal', overflowWrap: 'anywhere' } : {}, disabled: disabled, onClick: () => handleMenuClose(option.value), children: option.label }, option.value))) })] }));
};
